
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const HomePage = () => {
  const services = [
    {
      icon: 'ri-fire-line',
      title: 'Yangın Tüpü Dolum',
      description: 'Tüm tip yangın söndürme tüplerinin profesyonel dolum hizmeti',
      link: '/hizmetlerimiz/yangin-tupu-dolum',
    },
    {
      icon: 'ri-tools-line',
      title: 'Yangın Tüpü Bakım',
      description: 'Periyodik kontrol ve bakım hizmetleri ile güvenliğiniz her zaman güncel',
      link: '/hizmetlerimiz/yangin-tupu-bakim',
    },
    {
      icon: 'ri-fire-fill',
      title: 'Baca Temizliği',
      description: 'Ev ve işletmeler için profesyonel baca temizliği hizmeti',
      link: '/hizmetlerimiz/baca-temizligi',
    },
    {
      icon: 'ri-restaurant-line',
      title: 'Davlumbaz Söndürme Sistemi',
      description: 'Mutfak yangın güvenliği için otomatik söndürme sistemleri',
      link: '/hizmetlerimiz/otomatik-davlumbaz-sondurme-sistemi',
    },
  ];

  const steps = [
    {
      icon: 'ri-phone-line',
      title: 'İletişim',
      description: 'Bizi arayın veya WhatsApp üzerinden ulaşın',
    },
    {
      icon: 'ri-calendar-check-line',
      title: 'Randevu',
      description: 'Size uygun tarih ve saatte hizmet planlıyoruz',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Uygulama',
      description: 'Profesyonel ekibimiz hizmeti tamamlıyor',
    },
  ];

  const features = [
    {
      icon: 'ri-time-line',
      title: 'Hızlı Servis',
      description: 'Aynı gün hizmet imkanı',
    },
    {
      icon: 'ri-shield-star-line',
      title: 'Güvenilir',
      description: 'Yılların deneyimi ve uzmanlığı',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '7/24 Destek',
      description: 'Her zaman yanınızdayız',
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Uygun Fiyat',
      description: 'Şeffaf ve rekabetçi fiyatlar',
    },
  ];

  const blogPosts = [
    {
      title: 'Yangın Tüpü Dolumu Ne Zaman Yapılır?',
      excerpt: 'Yangın tüplerinin düzenli dolum periyotları ve önemini öğrenin.',
      image: 'https://public.readdy.ai/ai/img_res/09f243f2548a62906c1db2b9f266c887.jpg',
      link: '/blog',
    },
    {
      title: 'Baca Temizliği Neden Önemlidir?',
      excerpt: 'Ev ve işletmelerde baca temizliğinin yangın riskini nasıl azalttığını keşfedin.',
      image: 'https://readdy.ai/api/search-image?query=chimney%20cleaning%20service%20professional%20worker%20cleaning%20residential%20chimney%20with%20modern%20equipment%20clean%20white%20background%20safety%20focused%20bright%20daylight&width=400&height=250&seq=blog2&orientation=landscape',
      link: '/blog',
    },
    {
      title: 'Otomatik Davlumbaz Söndürme Sistemi Nedir?',
      excerpt: 'Mutfak yangınlarına karşı en etkili koruma sistemini tanıyın.',
      image: 'https://readdy.ai/api/search-image?query=automatic%20kitchen%20hood%20fire%20suppression%20system%20in%20modern%20commercial%20restaurant%20kitchen%20with%20stainless%20steel%20equipment%20clean%20white%20walls%20professional%20safety%20installation&width=400&height=250&seq=blog3&orientation=landscape',
      link: '/blog',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url(https://readdy.ai/api/search-image?query=modern%20abstract%20fire%20safety%20background%20with%20red%20and%20black%20gradient%20geometric%20patterns%20professional%20industrial%20safety%20theme%20clean%20minimalist%20design%20high%20contrast%20dramatic%20lighting&width=1920&height=1080&seq=hero1&orientation=landscape)',
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center w-full">
          <h2 className="font-display font-bold text-5xl md:text-6xl lg:text-7xl text-white mb-6 leading-tight">
            Yangın Güvenliğiniz<br />Bizim İşimiz
          </h2>
          <p className="text-xl md:text-2xl text-white/90 mb-8 max-w-3xl mx-auto">
            Yangın söndürme tüpü satış, dolum, bakım ve baca temizliği hizmetlerinde profesyonel çözümler
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a 
              href="tel:+905XXXXXXXXX" 
              className="bg-primary-600 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-primary-700 transition-all hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer inline-flex items-center space-x-2"
            >
              <i className="ri-phone-line"></i>
              <span>Hemen Ara</span>
            </a>
            <a 
              href="https://wa.me/905XXXXXXXXX" 
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="bg-green-500 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-green-600 transition-all hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer inline-flex items-center space-x-2"
            >
              <i className="ri-whatsapp-line"></i>
              <span>WhatsApp</span>
            </a>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="font-display font-bold text-4xl md:text-5xl text-dark-900 mb-4">
              Hizmetlerimiz
            </h2>
            <p className="text-lg text-dark-600 max-w-2xl mx-auto">
              Yangın güvenliği konusunda ihtiyacınız olan tüm hizmetleri profesyonel ekibimizle sunuyoruz
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {services.map((service, index) => (
              <Link
                key={index}
                to={service.link}
                className="bg-white border-2 border-dark-100 rounded-xl p-8 hover:border-primary-500 hover:shadow-xl transition-all group cursor-pointer"
              >
                <div className="w-16 h-16 bg-primary-100 rounded-lg flex items-center justify-center mb-6 group-hover:bg-primary-600 transition-colors">
                  <i className={`${service.icon} text-3xl text-primary-600 group-hover:text-white transition-colors`}></i>
                </div>
                <h3 className="font-display font-semibold text-xl text-dark-900 mb-3">
                  {service.title}
                </h3>
                <p className="text-dark-600 text-sm leading-relaxed">
                  {service.description}
                </p>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* How We Work Section */}
      <section className="py-20 bg-dark-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="font-display font-bold text-4xl md:text-5xl text-dark-900 mb-4">
              Nasıl Çalışıyoruz?
            </h2>
            <p className="text-lg text-dark-600 max-w-2xl mx-auto">
              Üç basit adımda profesyonel hizmet alın
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                <div className="bg-white rounded-xl p-8 text-center shadow-lg">
                  <div className="w-20 h-20 bg-primary-600 rounded-full flex items-center justify-center mx-auto mb-6">
                    <i className={`${step.icon} text-4xl text-white`}></i>
                  </div>
                  <div className="absolute -top-4 -right-4 w-12 h-12 bg-primary-600 rounded-full flex items-center justify-center text-white font-bold text-xl">
                    {index + 1}
                  </div>
                  <h3 className="font-display font-semibold text-2xl text-dark-900 mb-3">
                    {step.title}
                  </h3>
                  <p className="text-dark-600">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="font-display font-bold text-4xl md:text-5xl text-dark-900 mb-4">
              Neden İpek Yangın Söndürme?
            </h2>
            <p className="text-lg text-dark-600 max-w-2xl mx-auto">
              Yangın güvenliği konusunda güvenilir çözüm ortağınız
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {features.map((feature, index) => (
              <div key={index} className="text-center">
                <div className="w-20 h-20 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className={`${feature.icon} text-4xl text-primary-600`}></i>
                </div>
                <h3 className="font-display font-semibold text-xl text-dark-900 mb-3">
                  {feature.title}
                </h3>
                <p className="text-dark-600">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-primary-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-display font-bold text-4xl md:text-5xl text-white mb-6">
            Yangın Güvenliğinizi Ertelemeyin
          </h2>
          <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
            Hemen bizimle iletişime geçin ve ücretsiz keşif randevusu alın
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link 
              to="/iletisim" 
              className="bg-white text-primary-600 px-8 py-4 rounded-lg font-semibold text-lg hover:bg-dark-50 transition-all hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
            >
              Teklif Al
            </Link>
            <a 
              href="tel:+905XXXXXXXXX" 
              className="bg-dark-900 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-dark-800 transition-all hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
            >
              Hemen Ara
            </a>
          </div>
        </div>
      </section>

      {/* Blog Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="font-display font-bold text-4xl md:text-5xl text-dark-900 mb-4">
              Blog Yazılarımız
            </h2>
            <p className="text-lg text-dark-600 max-w-2xl mx-auto">
              Yangın güvenliği hakkında bilmeniz gerekenleri paylaşıyoruz
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {blogPosts.map((post, index) => (
              <Link
                key={index}
                to={post.link}
                className="bg-white border-2 border-dark-100 rounded-xl overflow-hidden hover:border-primary-500 hover:shadow-xl transition-all group cursor-pointer"
              >
                <div className="w-full h-48 overflow-hidden">
                  <img 
                    src={post.image} 
                    alt={post.title}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <h3 className="font-display font-semibold text-xl text-dark-900 mb-3 group-hover:text-primary-600 transition-colors">
                    {post.title}
                  </h3>
                  <p className="text-dark-600 text-sm">
                    {post.excerpt}
                  </p>
                </div>
              </Link>
            ))}
          </div>

          <div className="text-center mt-12">
            <Link 
              to="/blog" 
              className="inline-block bg-primary-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-primary-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              Tüm Yazıları Gör
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default HomePage;
